import { JSX } from "react";
import { toast } from "react-toastify";

function dismissReportQueued(): void {
  toast.dismiss();
}

function toastReportQueued(reportName: string): void {
  toast.info(
    <ReportQueuedToastBody reportName={reportName} />,
    {
      closeOnClick: true,
      containerId: "z-index-9999",
      draggable: false,
    });
}

function toastQueueReportFailed(reportName: string): void {
  toast.error(
    <span>{reportName || "Requested report"} < br /> has failed, please try again or contact your system administrator.</span>,
    {
      closeOnClick: true,
      containerId: "z-index-9999",
      draggable: false,
    }
  );
}

function ReportQueuedToastBody(props: { reportName: string }): JSX.Element {
  return (
    <span>{props.reportName || "Requested report"} < br /> has been queued for generation, check < br /> email / Reports page for status.</span>
  );
}

export {
  dismissReportQueued as dismiss,
  toastReportQueued as toastInfo,
  toastQueueReportFailed as toastError,
};
